// extracted by css-extract-rspack-plugin
module.exports =  {"actions":"OpportunityDetailsActions__actions___jjSPw"};